import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';

@Component({
  selector: 'maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MaintenancePageComponent implements OnInit {
  errorTitle: string;
  errorMessage: string;

  constructor(private route: ActivatedRoute, private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this._fuseTranslationLoaderService.loadTranslations(english, vn);
  }

  ngOnInit() {
    this.route.data.subscribe(routeData => {
      this.errorTitle = routeData.errorTitle;
      this.errorMessage = routeData.errorMessage;
    });
  }
}
